module.exports = __webpack_public_path__ + "img/doinsport-icon.624bb9e8.svg";